import React from 'react'
import styled from 'styled-components'
import * as constants from '../../../static/constants'

interface IProps {
  headerContent?: React.ReactNode
  children: React.ReactNode
  layoutRef?: React.MutableRefObject<HTMLDivElement>
}

export const FullScreenReservationLayout: React.VFC<IProps> = ({
  headerContent,
  children,
  layoutRef,
}) => {
  return (
    <ReservationLayout>
      {headerContent && (
        <div className="header">
          <div className="header_inner">{headerContent}</div>
        </div>
      )}
      <div className="content" ref={layoutRef}>
        {children}
      </div>
    </ReservationLayout>
  )
}
const ReservationLayout = styled.div`
  padding: ${constants.TOPPAGE_HEADER_HEIGHT}px 80px 0;
  @media (max-width: ${constants.BREAKPOINT_DESKTOP_XL}px) {
    padding: 5.5rem 80px 0;
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    padding: 5.5rem 4rem 0px;
  }
  @media screen and (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    padding: 5.5rem 1.6rem 0px;
  }

  .header {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${constants.TOPPAGE_HEADER_HEIGHT}px;
    width: 100%;
    box-shadow: ${constants.COLORS.cardShadow};
    background: ${constants.COLORS.white};
    .header_inner {
      max-width: 128rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      padding: 0 8rem;
      @media (max-width: ${constants.BREAKPOINT_DESKTOP_XL}px) {
        max-width: 128rem;
      }
      @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
        padding: 0 4rem;
      }
    }
    @media (max-width: ${constants.BREAKPOINT_DESKTOP_XL}px) {
      height: 5.5rem;
    }
  }

  .content {
    display: flex;
    height: calc(100dvh - 10rem);
    margin: 0 -8rem;
    padding: 0 8rem;
    overflow-x: hidden;
    overflow-y: auto;
    @media (max-width: ${constants.BREAKPOINT_DESKTOP_XL}px) {
      height: calc(100dvh - 5.5rem);
    }
    @media screen and (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
      margin: 0 -5rem;
      padding: 0 5rem;
    }
    @media screen and (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      margin: 0 -4rem;
      padding: 0 4rem;
    }
    @media screen and (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      margin: 0 -1.6rem;
      padding: 0 1.6rem;
    }
  }
`
